import PlayerEvent from '../../events/player.event';
import * as AdEvents from '../../events/ad.events';
import { Handler } from '../utils/handler';
import { logDebugging } from '../../../log/logger';

export default class NativePlayerListeners {
  constructor(videoData) {
    // eslint-disable-next-line no-undef
    this.videoSlot = document.getElementById(videoData.idVideoElement);
    this.id = Math.random() * 100000;
    this.isFirstStart = false;
    this.PlayerEvent = new PlayerEvent('onNativePlayerEvent');
    this.precompleteEventReached = false;
    this.addHandlers();
    this.duration = 0;
    this.isStopped = false;
    this.nextQuartileIndex = 0;
    this.quartileEvents = [
      //  { event: AdEvents.AdImpression, value: 0, reached: false },
      { event: AdEvents.AdVideoStart, value: 0, reached: false },
      { event: AdEvents.AdVideoFirstQuartile, value: 25, reached: false },
      { event: AdEvents.AdVideoMidpoint, value: 50, reached: false },
      { event: AdEvents.AdVideoThirdQuartile, value: 75, reached: false },
      // { event: AdEvents.AdVideoComplete, value: 100, reached: false },
    ];
  }

  addHandlers() {
    // let percentPlayed = 0;
    if (this.videoSlot != null) {
      this.handlers = [];
      // Handler() = Handler();
      this.handlers[0] = Handler.addListener(
        this.videoSlot,
        'play',
        () => {
          logDebugging('[NativePlayerListeners]activoListeners PLAY ');
          this.isStopped = false;
          if (!this.isFirstStart) {
            this.dispatchEvent([
              AdEvents.AdStarted,
              this.videoSlot.currentTime,
              this.videoSlot.duration,
            ]);
            this.timeInterval = setInterval(() => {
              this.updateTime();
            }, 1000);
            this.isFirstStart = true;
          }
        },
        false,
      );
      this.handlers[1] = Handler.addListener(this.videoSlot, 'timeupdate', () => {
        // logDebugging(
        //   `[NativePlayerListeners]activoListeners TIMEUPDATE ${this.videoSlot.currentTime} -- ${this.videoSlot.duration}`,
        // );
        // percentPlayed = (this.videoSlot.currentTime * 100.0) / this.videoSlot.duration;
        // if (
        //   typeof this.quartileEvents[this.nextQuartileIndex] !== 'undefined' &&
        //   percentPlayed >= this.quartileEvents[this.nextQuartileIndex].value &&
        //   this.nextQuartileIndex < 6 &&
        //   !this.quartileEvents[this.nextQuartileIndex].reached
        // ) {
        //   this.quartileEvents[this.nextQuartileIndex].reached = true;
        //   // logDebugging(`percentPlayed ${percentPlayed}`);
        //   // logDebugging(
        //   //   `this.quartileEvents[this.nextQuartileIndex] ${
        //   //     this.quartileEvents[this.nextQuartileIndex].event
        //   //   }`,
        //   // );
        //   const lastQuartileEvent = this.quartileEvents[this.nextQuartileIndex].event;
        //   this.nextQuartileIndex += 1;
        //   this.dispatchEvent([
        //     lastQuartileEvent,
        //     Math.abs(this.videoSlot.currentTime - this.videoSlot.duration),
        //     this.videoSlot.duration,
        //   ]);
        // }
        // if (!Number.isNaN(this.videoSlot.duration) && this.videoSlot.duration !== this.duration) {
        //   this.duration = this.videoSlot.duration;
        //   this.dispatchEvent([
        //     AdEvents.AdDurationChange,
        //     this.videoSlot.currentTime,
        //     this.videoSlot.duration,
        //   ]);
        // } else {
        // if (this.current !== this.videoSlot.currentTime.toFixed()) {
        //   this.current = this.videoSlot.currentTime.toFixed();
        //   this.dispatchEvent([
        //     AdEvents.AdRemainingTimeChange,
        //     this.videoSlot.currentTime.toFixed(),
        //     this.videoSlot.duration,
        //     Math.abs(this.videoSlot.currentTime - this.videoSlot.duration),
        //   ]);
        // }
        // }
      });
      this.handlers[2] = Handler.addListener(
        this.videoSlot,
        'error',
        (err) => {
          logDebugging('[NativePlayerListeners]activoListeners error');
          // logDebugging(err);
          try {
            if (this.src !== 'undefined' && this.src !== '') {
              switch (err.target.error.code) {
                case err.target.error.MEDIA_ERR_ABORTED:
                  break;
                case err.target.error.MEDIA_ERR_NETWORK:
                  this.dispatchEvent([AdEvents.AdError, 0, 0]);
                  break;
                case err.target.error.MEDIA_ERR_DECODE:
                  this.dispatchEvent([AdEvents.AdError, 0, 0]);
                  break;
                case err.target.error.MEDIA_ERR_SRC_NOT_SUPPORTED:
                  this.dispatchEvent([AdEvents.AdError, 0, 0]);
                  break;
                default:
                  this.dispatchEvent([AdEvents.AdError, 0, 0]);
                  break;
              }
            }
          } catch (error) {
            logDebugging('[NativePlayerListeners] warning');
          }
        },
        false,
      );

      this.handlers[3] = Handler.addListener(
        this.videoSlot,
        'waiting',
        () => {
          logDebugging('[NativePlayerListeners]activoListeners WAITING');
          // this.dispatchEvent([AdEvents.AdError, 0, 0]);
        },
        false,
      );

      this.handlers[4] = Handler.addListener(
        this.videoSlot,
        'playing',
        () => {
          // si la ruta del video es sustituida, el player no continua con el evento play, sino con el playing
          logDebugging(
            `[NativePlayerListeners]activoListeners PLAYING paused? ${this.videoSlot.paused}`,
          );
          if (!this.isFirstStart) {
            this.dispatchEvent([
              AdEvents.AdStarted,
              this.videoSlot.currentTime,
              this.videoSlot.duration,
            ]); // ESTA LINEA ES DE LA VERSION DEL PREFETCH
            this.isFirstStart = true;
          }
          if (!this.isStopped) {
            this.dispatchEvent([
              AdEvents.AdPlaying,
              this.videoSlot.currentTime,
              this.videoSlot.duration,
            ]);
          }
        },
        false,
      );

      this.handlers[5] = Handler.addListener(
        this.videoSlot,
        'suspend',
        () => {
          logDebugging(`[NativePlayerListeners]activoListeners SUSPEND this.src ${this.src}`);
          if (this.src !== 'undefined' && this.src !== '') {
            // this.dispatchEvent([PlayerEventNames.SUSPEND, 0, 0]);
          }
        },
        false,
      );

      this.handlers[6] = Handler.addListener(
        this.videoSlot,
        'abort',
        () => {
          logDebugging(`[NativePlayerListeners]activoListeners ABORT this.src ${this.src}`);
        },
        false,
      );

      this.handlers[7] = Handler.addListener(
        this.videoSlot,
        'loadeddata',
        () => {
          logDebugging('[NativePlayerListeners]activoListeners LOADEDDATA');
          // logDebugging("[NativePlayerListeners]duration " + this.videoSlot.duration);
          this.dispatchEvent([
            AdEvents.AdLoaded,
            this.videoSlot.currentTime,
            this.videoSlot.duration,
          ]);
        },
        false,
      );

      this.handlers[8] = Handler.addListener(
        this.videoSlot,
        'canplaythrough',
        () => {
          logDebugging(
            `[NativePlayerListeners]activoListeners CANPLAYTHROUGH - ${this.videoSlot.src}`,
          );
          this.dispatchEvent([
            AdEvents.AdCanplay,
            this.videoSlot.currentTime,
            this.videoSlot.duration,
          ]);
        },
        false,
      );

      this.handlers[10] = Handler.addListener(
        this.videoSlot,
        'pause',
        () => {
          // logDebugging(
          //   `[NativePlayerListeners]activoListeners PAUSE this.videoSlot ${this.videoSlot.currentTime} this.videoSlot.duration ${this.videoSlot.duration}`,
          // );
          // this.remove();
          if (this.videoSlot.currentTime < this.videoSlot.duration && !this.isStopped) {
            // logDebugging('[NativePlayerListeners]activoListeners PAUSE 1 this.videoSlot ');

            this.dispatchEvent([
              AdEvents.AdPaused,
              this.videoSlot.currentTime,
              this.videoSlot.duration,
            ]);
          } else if (this.videoSlot.currentTime >= this.videoSlot.duration && !this.isStopped) {
            // hay sistemas de ios que mandan un pause al final del video :(
            // logDebugging('[NativePlayerListeners]activoListeners PAUSE 2 this.videoSlot ');
            this.isStopped = true;
            this.remove();
            // logDebugging(
            //   `[NativePlayerListeners]activoListeners PAUSE envio END this.videoSlot.currentTime ${this.videoSlot.currentTime} this.videoSlot.duration ${this.videoSlot.duration}`,
            // );
            clearInterval(this.timeInterval);
            this.dispatchEvent([
              AdEvents.AdStopped,
              this.videoSlot.currentTime,
              this.videoSlot.duration,
            ]);
          }
        },
        false,
      );

      this.handlers[11] = Handler.addListener(
        this.videoSlot,
        'canplay',
        () => {
          logDebugging('[NativePlayerListeners]activoListeners canplay');
        },
        false,
      );

      this.handlers[12] = Handler.addListener(
        this.videoSlot,
        'volumechange',
        () => {
          // logDebugging(
          //   `[NativePlayerListeners]activoListeners volumechange ${this.videoSlot.muted}`,
          // );
          if (this.videoSlot.muted) {
            this.dispatchEvent([
              AdEvents.AdMute,
              this.videoSlot.currentTime,
              this.videoSlot.duration,
            ]);
          } else {
            this.dispatchEvent([
              AdEvents.AdUnmute,
              this.videoSlot.currentTime,
              this.videoSlot.duration,
            ]);
          }
          this.dispatchEvent([AdEvents.AdVolumeChange, this.videoSlot.volume]);
        },
        false,
      );

      this.handlers[13] = Handler.addListener(
        this.videoSlot,
        'ended',
        () => {
          logDebugging('[NativePlayerListeners]activoListeners ENDED');
          if (!this.isStopped) {
            logDebugging('stop timeupdate');
            clearInterval(this.timeInterval);
            this.isStopped = true;
            this.remove();
            this.dispatchEvent([
              AdEvents.AdStopped,
              this.videoSlot.currentTime,
              this.videoSlot.duration,
            ]);
          }
        },
        false,
      );
    }
  }

  updateTime() {
    // logDebugging('timeupdate');
    if (this.current !== this.videoSlot.currentTime.toFixed()) {
      this.current = this.videoSlot.currentTime.toFixed();
      this.throwQuartiles();
      this.dispatchEvent([
        AdEvents.AdRemainingTimeChange,
        this.videoSlot.currentTime.toFixed(),
        this.videoSlot.duration,
        Math.abs(this.videoSlot.currentTime - this.videoSlot.duration),
      ]);
    }
  }

  throwQuartiles() {
    const percentPlayed = (this.videoSlot.currentTime * 100.0) / this.videoSlot.duration;
    if (
      typeof this.quartileEvents[this.nextQuartileIndex] !== 'undefined' &&
      percentPlayed >= this.quartileEvents[this.nextQuartileIndex].value &&
      this.nextQuartileIndex < 6 &&
      !this.quartileEvents[this.nextQuartileIndex].reached
    ) {
      this.quartileEvents[this.nextQuartileIndex].reached = true;
      logDebugging(`percentPlayed ${percentPlayed}`);
      logDebugging(
        `this.quartileEvents[this.nextQuartileIndex] ${
          this.quartileEvents[this.nextQuartileIndex].event
        }`,
      );
      const lastQuartileEvent = this.quartileEvents[this.nextQuartileIndex].event;
      this.nextQuartileIndex += 1;
      this.dispatchEvent([
        lastQuartileEvent,
        Math.abs(this.videoSlot.currentTime - this.videoSlot.duration),
        this.videoSlot.duration,
      ]);
    }
  }

  remove() {
    this.handlers.forEach(Handler.removeListener);
    // this.handlers.forEach(Handler.removeListener);
  }

  skip() {
    this.remove();
    this.dispatchEvent([AdEvents.AdSkipped, this.videoSlot.currentTime, this.videoSlot.duration]);
  }

  replay() {
    this.remove();
    this.dispatchEvent([AdEvents.AdReplay, this.videoSlot.currentTime, this.videoSlot.duration]);
  }

  playError() {
    this.dispatchEvent([AdEvents.AdPlayError, this.videoSlot.currentTime, this.videoSlot.duration]);
  }

  dispatchEvent(arg) {
    this.PlayerEvent.fire(this, { message: arg });
  }
}
